import { getData } from '@/utils/axiosUtils';

const getRingCentralLoginLink = async (
    companyId,
    location = window.location.href,
) => {
    return await getData(
        `/company/${companyId}/RingCentralLoginLink?domain=${location}`,
    );
};

export default getRingCentralLoginLink;
